import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TractorsFuelConsumptionWidgetComponent } from './tractors-fuel-consumption-widget.component';
import {DxChartModule} from 'devextreme-angular';



@NgModule({
  declarations: [TractorsFuelConsumptionWidgetComponent],
    imports: [
        CommonModule,
        DxChartModule
    ],
  exports: [TractorsFuelConsumptionWidgetComponent]
})
export class TractorsFuelConsumptionWidgetModule { }
